import { prop, propArray, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Case } from "../../cases/_types/case";
import { MailMessageRecipient } from "./mail-message-receipt";
import { Relationship } from "src/app/core/jsonapi/relationship";
import { RelationshipArray } from "src/app/core/jsonapi/relationship-array";
import { User } from "../../users/_types/user";

export enum WhatsappMessageState {
    Pending = "Pending",
    Error = "Error",
    Sent = "Sent",
    Received = "Received",
    Sending = "Sending"
}
export enum WhatsappMessageDirection {
    Outbound = "Outbound",
    Inbound = "Inbound"
}


export class WhatsappMessage extends Resource {
    public override type = 'whatsappMessages';

    @prop()
    public templateId?: string;

    @prop()
    public caseId?: string;

    @prop()
    public contentSid?: string;

    @prop()
    public content!: string;

    @prop()
    public direction: WhatsappMessageDirection = WhatsappMessageDirection.Outbound;

    @prop()
    public state: WhatsappMessageState = WhatsappMessageState.Pending;

    @prop()
    @required()
    public stateDate: Date = new Date();


    @prop()
    public stateInfo?: string;

    @prop()
    public phoneNumber!: string;

    @prop()
    public createdAt!: Date;

    @prop()
    public createdBy!: string;

    @propObject()
    public createdByUser?: User;

}